<template>
  <div id="app">
    <!-- Menu -->
    <app-menu></app-menu>
    <!-- .end Menu -->

    <!-- Banner -->
    <app-banner></app-banner>
    <!-- .end Banner -->

    <!-- Serviços -->
    <app-services></app-services>
    <!-- .end Serviços -->

    <!-- Canal do Youtube - Inclusão na Lata -->
    <app-canal-youtube></app-canal-youtube>
    <!-- .end Canal do Youtube - Inclusão na Lata -->

    <!-- Footer -->
    <app-footer></app-footer>
    <!-- .end Footer -->

  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      msg: 'Incluir da Certo'
    }
  }
}

// Ancora
function Ancora(Menu) {
  $('html, body').animate({
  scrollTop: $("#" + Menu).offset(20).top - 105}, 1000);
}
</script>



// WEBPACK FOOTER //
// src/App.vue